module.exports = __webpack_public_path__ + "media/images/icons/map/outgoing-icon-ffdaea071948948b6fe738cac7af0034.svg";